<template>
    <div class="live-banner" v-if="Object.keys(detailData).length>0">
      <div class="banner-bg" :style="{backgroundImage:`url(${detailData.url})`}"></div>
      <div class="inner-banner">
       <img :src="detailData.url" alt="" class="live-img">
      <div class="live-info">
        <div class="live-title common-ecllipse">{{detailData.title}}</div>
        <div class="live-desc common-ecllipse" v-if="detailData.briefIntroduction" :title="detailData.briefIntroduction">{{detailData.briefIntroduction}}</div>
        <div class="live-desc common-ecllipse" v-else></div>
        <div class="live-time"><img :src="require('@/assets/image/time@2x.png')" class="desc-icon" alt=""/>{{detailData.startTimeStr ? detailData.startTimeStr : '暂无数据'}}</div>
        <div class="live-speaker"><img :src="require('@/assets/image/man@2x.png')" class="desc-icon" alt=""/>{{detailData.speaker ? detailData.speaker : '暂无数据'}}</div>
        <div class="btn-wrap">
            <div v-if="detail && (detail.roadShowStatus !== 2) && (detail.pcView !== 2)" class="live-enter mouse-style" :class="{'visiable': !detailData || !detailData.liveUrl}" @click.stop="enterLive">进入直播</div>
            <div class="mobile-watch mouse-style"  @click.stop="mobieWatch">手机端查看</div>
        </div>
      </div>
      </div>
    </div>
</template>
<script>
export default {
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      detailData: {}
    }
  },
  methods: {
    mobieWatch () {
      this.$emit('mobileWatch')
    },
    enterLive () {
      this.$emit('enterLive', this.detailData)
    }
  },
  created () {
    this.detailData.briefIntroduction = ''
  }
}
</script>
<style scoped lang="scss">
.live-banner{
  height:326px;
  width:100%;
  position:relative;
  background-color:#000;
}
.banner-bg{
  height:326px;
  width:100%;
  filter:blur(20px);
  opacity:.7;
  background-size:100% 100%;

}
.inner-banner{
  display:flex;
  align-items: center;
  height:326px;
  position:absolute;
  left:0;
  right:0;
  top:0;
}
.live-img{
  width: 486px;
  height: 273px;
  margin: 0 24px 0 360px;
  border-radius:6px;
}
.live-info{
  flex:1;
  color:#fff;
  height: 273px;
  box-sizing:border-box;
  width: calc(100% - 870px);
}
.live-title{
  font-size:30px;
  font-weight: 500;
text-align: left;
line-height: 42px;
}
.live-desc{
  font-size: 14px;
font-family: PingFangSC, PingFangSC-Regular;
font-weight: 400;
text-align: left;
color: #cccccc;
line-height: 20px;
margin:12px 0 24px 0;
}
.live-time,.live-speaker{
  font-size: 12px;
font-family: PingFangSC, PingFangSC-Regular;
font-weight: 400;
text-align: justify;
line-height: 16px;
}
.live-time{
    margin-bottom:6px;
}
.desc-icon{
  width:10px;
  height:10px;
  margin-right:4px;
}
.btn-wrap{
    color:#fff;
    margin-top:102px;
    .visiable{
      background:#bfbdb5;
      color:#dedede;
    }
}
.live-enter,.mobile-watch{
 border-radius: 4px;
 height: 32px;
 line-height:32px;
 display:inline-block;
 font-size:14px;
 color:#fff;
 padding: 0 12px;
}
.live-enter{
opacity: 1;
background: #187fc3;
margin-right:24px;
}
.mobile-watch{
opacity: 0.5;
background: #000000;
}
</style>
